import { render, staticRenderFns } from "./ServiceChoice.vue?vue&type=template&id=32164806&scoped=true&"
import script from "./ServiceChoice.vue?vue&type=script&lang=js&"
export * from "./ServiceChoice.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChoice.vue?vue&type=style&index=0&id=32164806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32164806",
  null
  
)

export default component.exports